import React, { useState, useMemo } from "react";
import { Autocomplete, TextField, Typography, Stack } from "@mui/material";

/**
 * Autocomplete de pacientes que busca en la lista local de patients.json.
 */
export default function PatientAutocomplete({ patients, value, onChange }) {
  const [inputValue, setInputValue] = useState(value?.name || "");

  const options = useMemo(() => {
    if (!patients?.length) return [];
    if (!inputValue || inputValue.length < 2) return [];

    const q = inputValue.toLowerCase();
    return patients
      .filter(
        (p) =>
          p.name?.toLowerCase().includes(q) ||
          String(p.cipId).includes(q)
      )
      .slice(0, 20)
      .map((p) => ({
        cipId: p.cipId,
        name: p.name,
        label: `${p.name} (${p.cipId})`,
      }));
  }, [patients, inputValue]);

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(opt) => (typeof opt === "string" ? opt : opt.name || "")}
      isOptionEqualToValue={(opt, val) => opt.cipId === val.cipId}
      value={value}
      onChange={(_, newVal) => onChange(newVal)}
      inputValue={inputValue}
      onInputChange={(_, newInput) => setInputValue(newInput)}
      filterOptions={(x) => x}
      renderOption={(props, opt) => {
        const { key, ...rest } = props;
        return (
          <li key={opt.cipId} {...rest}>
            <Stack>
              <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                {opt.name}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.68rem" }}>
                CIP: {opt.cipId}
              </Typography>
            </Stack>
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Patient"
          placeholder="Search by name or CIP ID..."
          size="small"
        />
      )}
      noOptionsText={inputValue.length < 2 ? "Type 2+ characters to search" : "No patients found"}
      size="small"
    />
  );
}
